<template>
    <div class="wizard-step-indicator">
        <div v-for="step in totalSteps" :key="step" class="wizard-step-group">
            <div
                class="wizard-step-circle"
                :class="{
                    'is-completed': step < currentStep,
                    'is-active': step === currentStep,
                    'is-upcoming': step > currentStep,
                }"
            >
                <i v-if="step < currentStep" class="fas fa-check"></i>
                <span v-else>{{ step }}</span>
            </div>
            <div v-if="step < totalSteps" class="wizard-step-connector"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        currentStep: number;
        totalSteps: number;
    }>();
</script>
